
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function HomePage() {
  const [username, setUsername] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    const storedUsername = localStorage.getItem('username');
    
    if (!isLoggedIn) {
      navigate('/login');
      return;
    }
    
    if (storedUsername) {
      setUsername(storedUsername);
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('username');
    navigate('/login');
  };

  const serviceOptions = [
    {
      id: 'new-container',
      title: 'طلب حاوية جديدة',
      description: 'طلب حاوية جديدة لموقعك',
      icon: 'ri-add-box-line',
      color: 'from-green-500 to-green-600',
      route: '/new-request'
    },
    {
      id: 'replace-container',
      title: 'تبديل حاوية ممتلئة',
      description: 'استبدال حاوية ممتلئة بأخرى فارغة',
      icon: 'ri-refresh-line',
      color: 'from-blue-500 to-blue-600',
      route: '/replace-request'
    },
    {
      id: 'final-pickup',
      title: 'رفع نهائي للحاوية',
      description: 'طلب رفع نهائي للحاوية',
      icon: 'ri-truck-line',
      color: 'from-orange-500 to-orange-600',
      route: '/pickup-request'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50" dir="rtl">
      {/* Header */}
      <div className="bg-gradient-to-r from-green-500 to-blue-500 text-white p-4 fixed w-full top-0 z-10">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center ml-3">
              <i className="ri-truck-line text-xl"></i>
            </div>
            <div>
              <h1 className="font-bold text-lg">نظام إدارة الحاويات</h1>
              <p className="text-sm opacity-90">مرحباً، {username}</p>
            </div>
          </div>
          <button
            onClick={handleLogout}
            className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30 transition-colors"
          >
            <i className="ri-logout-box-line text-xl"></i>
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="pt-20 pb-20 px-4">
        {/* Welcome Section */}
        <div className="bg-white rounded-2xl shadow-sm p-6 mb-6">
          <div className="text-center">
            <img 
              src="https://public.readdy.ai/ai/img_res/bb5f8297fa600b042ca69201ce080783.jpg"
              alt="نظام إدارة الحاويات"
              className="w-full h-32 object-cover rounded-lg mb-4"
            />
            <h2 className="text-xl font-bold text-gray-800 mb-2">إدارة سهلة وفعالة</h2>
            <p className="text-gray-600 text-sm">اختر الخدمة المطلوبة من الخيارات أدناه</p>
          </div>
        </div>

        {/* Service Options */}
        <div className="space-y-4">
          {serviceOptions.map((service) => (
            <button
              key={service.id}
              onClick={() => navigate(service.route)}
              className="w-full bg-white rounded-2xl shadow-sm p-6 hover:shadow-md transition-all duration-200 text-right"
            >
              <div className="flex items-center">
                <div className={`w-16 h-16 bg-gradient-to-r ${service.color} rounded-xl flex items-center justify-center ml-4 flex-shrink-0`}>
                  <i className={`${service.icon} text-white text-2xl`}></i>
                </div>
                <div className="flex-1 text-right">
                  <h3 className="font-bold text-gray-800 text-lg mb-1">{service.title}</h3>
                  <p className="text-gray-600 text-sm">{service.description}</p>
                </div>
                <div className="w-8 h-8 flex items-center justify-center mr-2">
                  <i className="ri-arrow-left-line text-gray-400"></i>
                </div>
              </div>
            </button>
          ))}
        </div>

        {/* Quick Stats */}
        <div className="bg-white rounded-2xl shadow-sm p-6 mt-6">
          <h3 className="font-bold text-gray-800 mb-4 text-right">إحصائيات سريعة</h3>
          <div className="grid grid-cols-2 gap-4">
            <div className="text-center p-4 bg-green-50 rounded-xl">
              <div className="text-2xl font-bold text-green-600">12</div>
              <div className="text-sm text-gray-600">طلبات منجزة</div>
            </div>
            <div className="text-center p-4 bg-blue-50 rounded-xl">
              <div className="text-2xl font-bold text-blue-600">3</div>
              <div className="text-sm text-gray-600">طلبات قيد التنفيذ</div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Navigation */}
      <div className="fixed bottom-0 w-full bg-white border-t border-gray-200 px-4 py-2">
        <div className="grid grid-cols-4 gap-1">
          <button className="flex flex-col items-center py-2 px-1 text-green-500">
            <div className="w-6 h-6 flex items-center justify-center mb-1">
              <i className="ri-home-fill text-lg"></i>
            </div>
            <span className="text-xs">الرئيسية</span>
          </button>
          <button 
            onClick={() => navigate('/requests')}
            className="flex flex-col items-center py-2 px-1 text-gray-400 hover:text-gray-600"
          >
            <div className="w-6 h-6 flex items-center justify-center mb-1">
              <i className="ri-file-list-line text-lg"></i>
            </div>
            <span className="text-xs">طلباتي</span>
          </button>
          <button 
            onClick={() => navigate('/notifications')}
            className="flex flex-col items-center py-2 px-1 text-gray-400 hover:text-gray-600"
          >
            <div className="w-6 h-6 flex items-center justify-center mb-1">
              <i className="ri-notification-line text-lg"></i>
            </div>
            <span className="text-xs">التنبيهات</span>
          </button>
          <button 
            onClick={() => navigate('/profile')}
            className="flex flex-col items-center py-2 px-1 text-gray-400 hover:text-gray-600"
          >
            <div className="w-6 h-6 flex items-center justify-center mb-1">
              <i className="ri-user-line text-lg"></i>
            </div>
            <span className="text-xs">الملف الشخصي</span>
          </button>
        </div>
      </div>
    </div>
  );
}
